module.exports = "/076c958321237351e457a25f1551005dcff1e8fc/2802fceba59929afdf19ed100f513c67.svg";